<template lang="html">
  <div class="background" :style="thisStyle"></div>
</template>

<script>
export default {
  props: {
    bg: {
      type: String,
      default: ''
    }
  },
  computed: {
    thisStyle: function () {
      if (this.bg) {
        var style = 'background-image: url(' + this.bg + ');'
        return style
      }
    }
  }
}
</script>

<style lang="scss">
  .background {
    top: 0;
    right: 0;
    position: fixed;
    background-position: center;
    background-size: cover;
    bottom: 0;
    left: 0;
    z-index: -1;
  }
</style>



// WEBPACK FOOTER //
// src/components/partial/background/Background.vue